import { useMemo, useState } from 'react'
import { DataTable } from '../components/DataTable'
import type { DataSection, RecordRow } from '../types'

export function RecordsPage({ section, title, rows, loading, onSelect }: { section: DataSection; title: string; rows: RecordRow[]; loading: boolean; onSelect: (row: RecordRow) => void }) {
  const [query, setQuery] = useState('')
  const filtered = useMemo(() => rows.filter(row => JSON.stringify(row).toLowerCase().includes(query.toLowerCase())), [rows, query])
  return <section className="content"><div className="toolbar"><input aria-label="Tìm kiếm" placeholder={`Tìm trong ${title.toLowerCase()}…`} value={query} onChange={event => setQuery(event.target.value)}/><span>{filtered.length} records</span></div><DataTable section={section} rows={filtered} loading={loading} onSelect={onSelect}/></section>
}
